"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListMenu = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const MoreVert_1 = __importDefault(require("@mui/icons-material/MoreVert"));
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const ListMenu = props => {
    const { children, dataTestId, disabled } = props;
    const [anchor, setAnchor] = (0, react_1.useState)(null);
    const open = Boolean(anchor);
    const handleMenuOpen = (event) => {
        setAnchor(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchor(null);
    };
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ui_kit_1.Button, { intent: "icon", onClick: handleMenuOpen, "aria-label": "more", id: "menu-button", "aria-controls": open ? "actions-menu" : undefined, "aria-expanded": open ? "true" : undefined, "aria-haspopup": "true", disabled: disabled, "data-testid": dataTestId, children: (0, jsx_runtime_1.jsx)(MoreVert_1.default, {}) }), (0, jsx_runtime_1.jsx)(ui_kit_1.Menu, { id: "actions-menu", open: open, anchorEl: anchor, onClose: handleMenuClose, onClick: handleMenuClose, keepMounted: true, children: children })] }));
};
exports.ListMenu = ListMenu;
//# sourceMappingURL=index.js.map